import React from 'react';
import { Grid } from '@material-ui/core';
import SummaryTable from './components/SummaryTable';
import StatisticsTable from './components/StatisticsTable';

const AgentStatistics = ({ agentId }) => {
    return (
        <Grid item xs={12} container alignContent="flex-start" spacing={2}>
            <SummaryTable agentId={agentId} />
            <StatisticsTable agentId={agentId} />
        </Grid>
    );
};

export default AgentStatistics;
